var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"hide-details":"","outlined":"","value":_vm.value,"rows":"2","auto-grow":"","disabled":_vm.readonly},on:{"input":val => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }